import { UserManager, WebStorageStateStore } from "oidc-client";
import CropwiseService from "./cropwiseService";
export default class CropwiseAuthService {
  
  userManager;
  user;
  cropwiseService;

  constructor() { 
    let that = this;
    this.cropwiseService = new CropwiseService();

    let redirectUri = `${process.env.VUE_APP_AD_REDIRECT_URI.endsWith('/')?process.env.VUE_APP_AD_REDIRECT_URI:process.env.VUE_APP_AD_REDIRECT_URI+'/'}`;

    const settings = {
      userStore: new WebStorageStateStore({ store: window.sessionStorage }),
      authority:`${process.env.VUE_APP_CROPWISE_AUTHORITY}`,
      client_id: `${process.env.VUE_APP_CROPWISE_CLIENT_ID}`,
      redirect_uri: redirectUri,
      response_type: "token",
      scope: 'read write',
      filterProtocolClaims: true,
      automaticSilentRenew:true,
      accessTokenExpiringNotificationTime:60,
      silentRequestTimeout:10000,
      silent_redirect_uri: `${process.env.VUE_APP_AD_SILENT_REDIRECT_URI}`,
      metadata: {
        issuer:`${process.env.VUE_APP_CROPWISE_ISSUER}`,
        authorization_endpoint: `${process.env.VUE_APP_CROPWISE_AUTHORITY}`
      }
    };

    that.userManager = new UserManager(settings);

    this.setUser();
  }

  async setUser(){
    let that=this;
    await that.getUser().then(user => {
      that.user = user;
    }); 
  }
  getUser() {
    let that = this;

    if (that.user) {
      let promise = new Promise(function (resolve,) {
        if(that.user.profile){
          resolve(that.user);
        }else{
          that.cropwiseService.getUser(that.user.access_token).then(user => {

            that.user = { ...user, access_token: that.user.access_token };
            resolve(that.user);

          });
        }
      });
    
      return promise;

    } else {

      let promise = new Promise(function (resolve,) {
        that.userManager.getUser().then(response => {
          if (response && response.access_token) {
            that.cropwiseService.getUser(response.access_token).then(user => {

              that.user = { ...user, access_token: response.access_token };
              resolve(that.user);

            });
          } else {
            resolve(response);
          }

        })
      });

      return promise;
    }
  }

  login() {
    return this.userManager.signinRedirect();
  }

  completeAuthentication() {
    let that =this;
    var promise = new Promise(function(resolve,){
      that.getUser().then(u=>{
        if(u==null || u.expired){
            that.userManager
            .signinRedirectCallback()
            .then(c => {
              that.user = c;
              resolve(that.user);
            })
            .catch(function (err) {
              resolve(`error:${err}`);
            });
        }else{
          resolve(u);
        }
      });
    });
    return promise; 
  }

  logout() {
    return this.cropwiseService.logout();
  }
  getToken() {
    let that = this;

    if (that.user && that.user.hasOwnProperty("access_token")) {
      
      var  promise= new Promise(function(resolve,){
        resolve(that.user.access_token);
      });
      
      return promise;

    } else {
      return that.getUser().then(u => {
        that.user = u;
        return u && u.access_token
      });
    }
  }

  silentRefresh(){
    
    let that = this;
  return that.userManager.signinSilent().then(u=>{
      that.user = u;
      return u;
    }).catch(function (err) {
      console.log(err);
      that.login();
  });
  }


}